import {
  ActivityFilterKey,
  useActivityListFilter,
  useSetActivityListFilter,
} from '@gripp/shared-logic';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { colors as CropCircleColors } from '../crop-circle/tokens';
import { DebouncedTextInput } from '../forms';

type ActivitySearchInputProps = {
  filterKey?: ActivityFilterKey.AssetActivity | ActivityFilterKey.Activity;
};

export const ActivitySearchInput: React.FC<ActivitySearchInputProps> = ({
  filterKey = ActivityFilterKey.Activity,
}) => {
  const { t } = useTranslation();
  const { data: activityFilter } = useActivityListFilter(filterKey);

  const { mutateAsync } = useSetActivityListFilter(filterKey);

  const [text, setText] = useState('');

  useEffect(() => {
    if (!text && activityFilter?.keyword) {
      setText(activityFilter.keyword);
    }
  }, [activityFilter]);

  const updateSearch = async (keyword: string) => {
    activityFilter.keyword = keyword;
    await mutateAsync(activityFilter);
  };

  return (
    activityFilter && (
      <DebouncedTextInput
        debounceTimeMs={500}
        debounceLength={1}
        debounceFunc={updateSearch}
        placeholder={t('activity.filter.searchPlaceholder')}
        value={text}
        onBlur={() => {}}
        onChangeText={(text) => setText(text)}
        height={32}
        width={'100%'}
        outlineStyle={styles.inputStyle}
        disableInnerStyle={true}
        autoFocus
      />
    )
  );
};

const styles = StyleSheet.create({
  inputStyle: {
    backgroundColor: CropCircleColors.neutral[200],
    borderWidth: 0,
    borderRadius: 8,
  },
});
